<template>
  <div class="charge-register">
    <div class="top-nav"></div>
    <div class="charge-register-container">
      <div class="head">
        <el-radio-group
          class="select-tab"
          v-model="selectedTab"
          @change="toUrl"
        >
          <el-radio-button label="收费登记"></el-radio-button>
          <el-radio-button label="收费表单"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="content">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          hide-required-asterisk
        >
          <div class="top">
            <el-form-item
              class="serviceContent"
              label="所属服务项："
              prop="serviceContent"
            >
              <div
                :class="{ active: index === activeIndex }"
                v-for="(item, index) in serviceContentList"
                :key="item.id"
                @click="clickServiceContent(item.id, index)"
              >
                {{ item.name }}
              </div>
            </el-form-item>
            <div class="orther-search">
              <div class="orther-search-title">其他筛选项：</div>
              <div class="orther-search-main">
                <el-form-item class="warehouse-name" label="仓库：" prop="name">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.warehouseId"
                    placeholder="请选择仓库"
                  >
                    <el-option
                      v-for="item in warehouse"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="warehouse-name" label="时间：" prop="date">
                  <el-date-picker
                    v-model="ruleForm.date"
                    type="date"
                    placeholder="请选择日期"
                    :picker-options="pickerOptions"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  class="project-name"
                  label="货主名称："
                  prop="userName"
                >
                  <el-select
                    class="gray white"
                    v-model="ruleForm.userName"
                    placeholder="请选择货主"
                    @change="changeUserName"
                    filterable
                  >
                    <el-option
                      v-for="item in customerList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="project-name"
                  label="项目名称："
                  prop="projectName"
                >
                  <el-select
                    class="gray white"
                    v-model="ruleForm.projectName"
                    placeholder="请选择项目"
                    @change="changeProjectName"
                  >
                    <el-option
                      v-for="item in projectNameList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="main">
            <div v-if="ruleForm.serviceContent === SERVICE_CONTENT['大宗服务']">
              <div class="main-title">基本信息</div>
              <div class="main-price">
                <el-form-item label="承运商：" prop="carrier" :key="1">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.carrier"
                    placeholder="请填写信息"
                    clearable
                    @keydown.enter.native="nextFocus($event)"
                  ></el-input>
                </el-form-item>
                <el-form-item label="目的地：" prop="destination" :key="2">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.destination"
                    placeholder="请填写信息"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="系统单号："
                  prop="systemNumber"
                  class="amount"
                  :key="3"
                >
                  <el-input
                    class="gray white"
                    v-model="ruleForm.systemNumber"
                    placeholder="请填写信息"
                    clearable
                    @keydown="event.keyCode = (event.keyCode == 13)?9:event.keyCode;"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="物流单号："
                  prop="logisticsNumber"
                  class="amount"
                  :key="4"
                >
                  <el-input
                    class="gray white"
                    v-model="ruleForm.logisticsNumber"
                    placeholder="请填写信息"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </div>
              <div class="remarks">
                <el-form-item label="备注：" prop="remarks" :key="5">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.remarks"
                    placeholder="请填写信息"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <div class="main-price">
                <el-form-item label="重量：" prop="weight" :key="24">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.weight"
                    placeholder="请输入"
                    @input="inputWeight(ruleForm.weight)"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="数量：" prop="nums" :key="6">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.nums"
                    placeholder="请输入数量"
                    @input="inputNums(ruleForm.nums)"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="单价：" prop="unitPrice" :key="7">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.unitPrice"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in stickerList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="金额：" prop="amount" class="amount" :key="8">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.amount"
                    placeholder="待计算"
                  >
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <div v-if="ruleForm.serviceContent === SERVICE_CONTENT['卸货服务']">
              <div class="main-title">基本信息</div>
              <div class="remarks">
                <el-form-item label="备注：" prop="remarks" :key="9">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.remarks"
                    placeholder="请填写信息"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <div class="main-price">
                <el-form-item label="数量：" prop="nums" :key="10">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.nums"
                    placeholder="请输入数量"
                    @input="inputTwoNums(ruleForm.nums)"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="单价：" prop="unitPrice" :key="11">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.unitPrice"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in stickerList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="金额：" prop="amount" class="amount" :key="12">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.amount"
                    placeholder="待计算"
                  >
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <div v-if="ruleForm.serviceContent === SERVICE_CONTENT['退货服务']">
              <div class="main-title">运单信息</div>
              <div class="main-price">
                <el-form-item label="运单号：" prop="waybillNo" :key="13">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.waybillNo"
                    placeholder="请填项信息"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="寄件人：" prop="sender" :key="14">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.sender"
                    placeholder="请填项信息"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="（选填）手机号"
                  prop="phone"
                  class="amount"
                  :key="15"
                >
                  <el-input
                    class="gray white"
                    v-model="ruleForm.phone"
                    placeholder="请填项信息"
                  >
                  </el-input>
                </el-form-item>
              </div>
              <div class="remarks">
                <el-form-item label="备注：" prop="remarks" :key="25">
                  <el-input
                    type="textarea"
                    class="gray white"
                    v-model="ruleForm.remarks"
                    placeholder="请填写信息"
                    clearable
                    resize="none"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="main-title">
                <span>商品信息</span>
                <span class="add-goodsInfo" @click="addGoodsInfo">添加</span>
              </div>
              <div
                class="main-price return-goods"
                v-for="(item, index) in ruleForm.returnGoodsInfo"
                :key="index"
              >
                <el-form-item
                  label="商品条码："
                >
                  <el-input
                    class="gray white"
                    v-model="item.goodsBarCode"
                    placeholder="请填写信息"
                    clearable
                    @change="changeGoodsBarCode(item.goodsBarCode, index)"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="商品名称："
                >
                  <el-select
                    class="gray white"
                    v-model="item.goodsName"
                    placeholder="请填项信息"
                    clearable
                    filterable
                    @visible-change="visibleChangeSelect($event,index)"
                    @blur="childrenSelectBlur"
                  >
                    <el-option
                      v-for="(item, index) in goodsNameList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="商品数量："
                >
                  <el-input
                    class="gray white"
                    v-model="item.quantity"
                    placeholder="请填写信息"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="次品数量："
                >
                  <el-input
                    class="gray white"
                    v-model="item.badQuantity"
                    placeholder="请填写信息"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="效期："
                >
                  <el-input
                    class="gray white"
                    v-model="item.validDate"
                    placeholder="请填写时间"
                    clearable
                    @input="inputValidDate"
                    @change="changeValidDate"
                    @focus="focusValidDate(item)"
                    @blur="blurValidDate(item)"
                  ></el-input>
                  <div class="allHislist" v-show="item.allHislistShow">
                    <div
                      class="hislist"
                      v-for="(i, index) in hislist"
                      :key="index"
                      @click="selectValidDateHislist(item,i)"
                      >
                      {{ i }}</div>
                  </div>
                </el-form-item>
                <span class="del-content">
                  <i
                    v-if="index !== 0"
                    class="el-icon-delete"
                    @click="removeGoodsInfo(index)"
                  ></i>
                </span>
              </div>
              <div class="main-price">
                <el-form-item label="数量：" prop="nums" :key="16">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.nums"
                    placeholder="请输入数量"
                    @input="inputNums(ruleForm.nums)"
                    clearable
                    disabled
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="单价：" prop="unitPrice" :key="17">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.unitPrice"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in stickerList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="金额：" prop="amount" class="amount" :key="18">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.amount"
                    placeholder="待计算"
                  >
                  </el-input>
                </el-form-item> -->
              </div>
            </div>
            <div v-if="ruleForm.serviceContent === SERVICE_CONTENT['增值服务']">
              <div class="main-title">商品信息</div>
              <div class="main-price">
                <el-form-item label="商品条码：" prop="goodsCode" :key="19">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.goodsCode"
                    placeholder="请填项信息"
                    @change="changeGoodsCode"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="商品名称：" prop="goodsName" :key="20">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.goodsName"
                    placeholder="请填项信息"
                    clearable
                    filterable
                    @blur="selectBlur"
                  >
                    <el-option
                      v-for="(item, index) in goodsNameList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="数量：" prop="nums" :key="21">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.nums"
                    placeholder="请输入数量"
                    @input="inputNums(ruleForm.nums)"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <div class="main-title">服务内容</div>
              <div class="main-price">
                <el-form-item label="服务名称：" prop="serverName" :key="22">
                  <el-select
                    class="gray white"
                    v-model="ruleForm.serverName"
                    placeholder="请选择服务名称"
                    @change="changeServiceName"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in serverNameList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="单价：" prop="unitPrice" :key="23">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.unitPrice"
                    placeholder="请填项单价"
                    clearable
                  ></el-input>
                  <!-- <el-select
                    class="gray white"
                    v-model="ruleForm.unitPrice"
                    placeholder="请选择"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in stickerList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item label="金额：" prop="amount" class="amount" :key="24">
                  <el-input
                    class="gray white"
                    v-model="ruleForm.amount"
                    placeholder="待计算"
                  >
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item class="foot">
              <el-button
                type="primary"
                class="btn-blue"
                @click="submitForm('ruleForm')"
                >保存</el-button
              >
              <el-button @click="cancel">清空</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Expenses from "models/expenses";
import Logistics from "models/logistics";
import ChargeRegister from "models/charge-register";
const expenses = new Expenses();
const logistics = new Logistics();
import { formatTimeToDate, modifyNetTitle } from "common/js/util";
import { saveValidDateHislist, getValidDateHislist } from "common/js/storage";
export default {
  data() {
    return {
      SERVICE_CONTENT: {
        大宗服务: 1,
        退货服务: 2,
        卸货服务: 3,
        增值服务: 4,
      },
      selectedTab: "收费登记",
      activeIndex: 0,
      warehouse: [],
      customerList: [],
      stickerList: [], // 贴标服务单价列表
      projectNameList: [],
      serviceContentList: [],
      goodsNameList: [],      // 商品名称列表
      goodsNameIndex: null,             // 退货服务中商品信息下标
      //设置今天以后不可选
      pickerOptions: {
        //限制时间
        selectableRange: this.selectableRange(),
        // 限制日期
        disabledDate: this.disabledDate,
      },
      allHislist: [],   //效期输入历史记录数据
      hislist: [],      //效期输入展示历史记录数据
      serverNameList: [],
      ruleForm: {
        warehouseId: "",
        date: formatTimeToDate(new Date()),
        userName: "",
        projectName: "",
        serviceContent: 1,
        remarks: "",
        weight: "",
        nums: "",
        serverName: "",
        unitPrice: "",
        amount: "",
        carrier: "",
        destination: "",
        systemNumber: "",
        logisticsNumber: "",
        goodsCode: "",
        goodsName: "",
        waybillNo: "",
        sender: "",
        phone: "",
        returnGoodsInfo: [
          {
            goodsBarCode	: "",
            goodsName: "",
            quantity: 1,
            badQuantity: 0,
            validDate: "",
            allHislistShow: false,     // 效期历史记录数据默认隐藏
          },
        ],
      },
      rules: {
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        userName: [
          {
            required: true,
            message: "请选择货主",
            trigger: "change",
          },
        ],
        projectName: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
        ],
        serviceContent: [
          {
            required: true,
            message: "请选择服务内容",
            trigger: "change",
          },
        ],
        weight: [
          {
            required: true,
            message: "请输入重量",
            trigger: "blur",
          },
        ],
        nums: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        unitPrice: [
          {
            required: true,
            message: "请选择单价",
            trigger: "blur",
          },
        ],
        carrier: [
          {
            required: true,
            message: "请输入承运商",
            trigger: "blur",
          },
        ],
        destination: [
          {
            required: true,
            message: "请输入目的地",
            trigger: "blur",
          },
        ],
        systemNumber: [
          {
            required: true,
            message: "请输入系统单号",
            trigger: "blur",
          },
        ],
        logisticsNumber: [
          {
            required: true,
            message: "请输入物流单号",
            trigger: "blur",
          },
        ],
        goodsCode: [
          {
            required: true,
            message: "请输入商品编码/规格",
            trigger: "blur",
          },
        ],
        goodsName: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
        ],
        waybillNo: [
          {
            required: true,
            message: "请输入运单号",
            trigger: "blur",
          },
        ],
        sender: [
          {
            required: true,
            message: "请选择寄件人",
            trigger: "blur",
          },
        ],
      },
    };
  },

  watch: {
    ruleForm: {
      handler(newVal) {
        if (this.ruleForm.serviceContent === this.SERVICE_CONTENT['退货服务']) {
          let num = 0
          this.ruleForm.returnGoodsInfo.map(i => {
            num += Number(i.quantity)
          })
          this.ruleForm.nums = num
        }
        this.ruleForm.amount = (
          Number(newVal.nums) * Number(newVal.unitPrice)
        ).toFixed(2);
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    modifyNetTitle('收费登记')
    this.getWarehouse();
    this.getCustomerList();
    this.getServiceContent();
    this.allHislist = getValidDateHislist()
    this.hislist = this.allHislist
  },
  methods: {
    selectableRange() {
      let date = new Date();
      let hour = date.getHours();
      hour = hour > 9 ? hour : "0" + hour;
      let minute = date.getMinutes();
      minute = minute > 9 ? minute : "0" + minute;
      let second = date.getSeconds();
      second = second > 9 ? second : "0" + second;
      let time = `${hour}:${minute}:${second}`;
      const selectableRange = `${time}-23:59:59`;
      return selectableRange;
    },
    disabledDate(date) {
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return date.getTime() > Date.now();
    },
    /* 限制数量为整数，可以为负 */
    inputNums(val) {
      let num = val.toString().match(/^(\-|\+)?\d*/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^(\-|\+)?\d*/g)[0]
        : "";
      this.ruleForm.nums = num;
    },
    /* 限制数量为2位小数，可以为负 */
    inputTwoNums(val) {
      let num = val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^(\-|\+)?\d*(\.?\d{0,2})/g)[0]
        : "";
      this.ruleForm.nums = num;
    },
    /* 限制单价为2位小数 */
    inputUnitPrice(val) {
      let price = val.toString().match(/^\d*(\.?\d{0,2})/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.ruleForm.unitPrice = price;
    },
    /* 限制重量为2位小数 */
    inputWeight(val) {
      let price = val.toString().match(/^\d*(\.?\d{0,2})/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      this.ruleForm.weight = price;
    },
    /* 获取仓库数据 */
    getWarehouse() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
          this.ruleForm.warehouseId = this.warehouse[0].id;
        }
      });
    },
    /* 获取货主名称 */
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    /* 获取项目名称 */
    getProjectNameList(customerId, warehouseId) {
      ChargeRegister.getProjectList(customerId, warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            let bulkUnitPriceArr = []
            value.bulkUnitPrice.map(val => {
              let bulkUnitPriceObj = {};
              bulkUnitPriceObj.name = val;
              bulkUnitPriceArr.push(bulkUnitPriceObj);
            })
            if (bulkUnitPriceArr.length === 0) {
              obj.bulkUnitPrice = [{name: 0}];
            } else {
              obj.bulkUnitPrice = bulkUnitPriceArr;
            }
            let unloadUnitPriceArr = []
            value.unloadUnitPrice.map(val => {
              let unloadUnitPriceObj = {};
              unloadUnitPriceObj.name = val;
              unloadUnitPriceArr.push(unloadUnitPriceObj);
            })
            if (unloadUnitPriceArr.length === 0) {
              obj.unloadUnitPrice = [{name: 0}];
            } else {
              obj.unloadUnitPrice = unloadUnitPriceArr;
            }
            let refundPriceRulesArr = []
            let refundPriceRulesObj = {};
            refundPriceRulesObj.name = value.refundPriceRules.unit_price;
            refundPriceRulesArr.push(refundPriceRulesObj);
            if (refundPriceRulesArr.length === 0) {
              obj.refundPriceRules = [{name: 0}];
            } else {
              obj.refundPriceRules = refundPriceRulesArr;
            }
            obj.refundPriceRules = refundPriceRulesArr;
            if (value.labelUnitPrice) {
              let arrayCopy = [];
              let stickerList = [];
              arrayCopy = value.labelUnitPrice;
              arrayCopy.map((i) => {
                let labelUnitPriceObj = {};
                labelUnitPriceObj.name = i;
                stickerList.push(labelUnitPriceObj);
              });
              if (stickerList.length === 0) {
                obj.labelUnitPrice = [{name: 0}];
              } else {
                obj.labelUnitPrice = stickerList;
              }
            }
            arr.push(obj);
          });
          this.projectNameList = arr;
          let projectNameObj = this.projectNameList[0]
          if (this.ruleForm.serviceContent === 1) {
            this.stickerList = projectNameObj.bulkUnitPrice;
            this.ruleForm.unitPrice = projectNameObj.bulkUnitPrice[0].name
          } else if (this.ruleForm.serviceContent === 2) {
            this.stickerList = projectNameObj.refundPriceRules;
            this.ruleForm.unitPrice = projectNameObj.refundPriceRules[0].name
          } else if (this.ruleForm.serviceContent === 3) {
            this.stickerList = projectNameObj.unloadUnitPrice;
            this.ruleForm.unitPrice = projectNameObj.unloadUnitPrice[0].name
          } else if (this.ruleForm.serviceContent === 4) {
            this.stickerList = projectNameObj.labelUnitPrice;
            // this.ruleForm.unitPrice = projectNameObj.labelUnitPrice[0].name
          }
          if (this.projectNameList.length === 0) {
            this.ruleForm.projectName = "";
          } else {
            this.ruleForm.projectName = this.projectNameList[0].id;
          }
        }
      });
    },
    /* 获取服务内容 */
    getServiceContent() {
      ChargeRegister.getServiceList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.serviceContentList = arr;
          this.ruleForm.serviceContent = this.serviceContentList[0].id;
        }
      });
    },
    /* 贴标服务列表 */
    initServiceLableList() {
      let projectId = this.ruleForm.projectName
      let data = {
        projectId
      }
      ChargeRegister.getServiceLableList(data).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.serviceName;
            obj.projectId = value.projectId;
            obj.unitPrice = value.unitPrice;
            arr.push(obj);
          });
          this.serverNameList = arr;
        } else {
          this.$message.error(res.message)
        }
      });
    },
    changeProjectName() {
      this.initServiceLableList()
    },
    changeServiceName(v) {
      let obj = this.serverNameList.find(item => {return item.id === v})
      this.ruleForm.unitPrice = obj.unitPrice
    },
    changeUserName() {
      let customerId, warehouseId;
      customerId = this.ruleForm.userName;
      warehouseId = this.ruleForm.warehouseId;
      this.getProjectNameList(customerId, warehouseId);
    },
    clickServiceContent(id, index) {
      this.activeIndex = index;
      this.ruleForm.nums = "";
      this.ruleForm.weight = "";
      this.ruleForm.unitPrice = "";
      this.ruleForm.serviceContent = id;
      this.projectNameList.map((i) => {
        if (i.id === this.ruleForm.projectName) {
          if (this.ruleForm.serviceContent === 1) {
            this.stickerList = i.bulkUnitPrice;
          } else if (this.ruleForm.serviceContent === 2) {
            this.stickerList = i.refundPriceRules;
          } else if (this.ruleForm.serviceContent === 3) {
            this.stickerList = i.unloadUnitPrice;
          } else if (this.ruleForm.serviceContent === 4) {
            this.stickerList = i.labelUnitPrice;
          }
          this.ruleForm.unitPrice = this.stickerList[0].name
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data
          let warehouseId = this.ruleForm.warehouseId;
          let dateStr = this.ruleForm.date;
          let customerId = this.ruleForm.userName;
          let projectId = this.ruleForm.projectName;
          let checkNum = Number(this.ruleForm.nums);
          let unitPrice = Number(this.ruleForm.unitPrice);
          if (this.ruleForm.serviceContent === this.SERVICE_CONTENT['大宗服务']) {
            let remarks = this.ruleForm.remarks;
            let expressName = this.ruleForm.carrier;
            let address = this.ruleForm.destination;
            let systemCode = this.ruleForm.systemNumber;
            let expressCode = this.ruleForm.logisticsNumber;
            let weight = this.ruleForm.weight;
            data = {
              warehouseId,
              customerId,
              projectId,
              dateStr,
              expressName,
              address,
              systemCode,
              expressCode,
              remarks,
              checkNum,
              unitPrice,
              weight
            };
            ChargeRegister.postBulkSave(data).then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.ruleForm.serviceContent === this.SERVICE_CONTENT['退货服务']) {
            let expressCode = this.ruleForm.waybillNo
            let sender = this.ruleForm.sender
            let phoneNumber = this.ruleForm.phone
            let remarks = this.ruleForm.remarks;
            this.ruleForm.returnGoodsInfo.map(i => {
              if (i.goodsName.name) {
                i.goodsName = i.goodsName.name
              }
            })
            let goodsList = this.ruleForm.returnGoodsInfo
            let flag = false
            goodsList.map(val => {
              this.$delete(val, 'allHislistShow')
              for(let key in val){
                if (key != 'validDate') {
                  if(!(val[key]).toString()){
                    flag = true
                    return; 
                  }
                }
              }
            })
            if (flag) {
              this.$message.error('请填项完整的商品信息')
              return
            }
            data = {
              warehouseId,
              customerId,
              projectId,
              dateStr,
              checkNum,
              // unitPrice,
              expressCode,
              sender,
              phoneNumber,
              goodsList,
              remarks
            };
            ChargeRegister.postRefundSave(data).then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.ruleForm.serviceContent === this.SERVICE_CONTENT['卸货服务']) {
            let remarks = this.ruleForm.remarks;
            data = {
              warehouseId,
              customerId,
              projectId,
              dateStr,
              remarks,
              checkNum,
              unitPrice,
            };
            ChargeRegister.postUnloadingSave(data).then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.ruleForm.serviceContent === this.SERVICE_CONTENT['增值服务']) {
            let goodsCode = this.ruleForm.goodsCode
            let extraServiceId = this.ruleForm.serverName
            let goodsName
            if (this.ruleForm.goodsName.name) {
              goodsName = this.ruleForm.goodsName.name
            } else {
              goodsName = this.ruleForm.goodsName
            }
            data = {
              warehouseId,
              customerId,
              projectId,
              dateStr,
              checkNum,
              unitPrice,
              goodsCode,
              goodsName,
              extraServiceId
            };
            ChargeRegister.postLabelSave(data).then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
              } else {
                this.$message.error(res.message);
              }
            });
          }
          this.cancel()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancel() {
      this.ruleForm.remarks = ""
      this.ruleForm.nums = ""
      this.ruleForm.weight = ""
      this.ruleForm.unitPrice = ""
      this.ruleForm.amount = ""
      this.ruleForm.carrier = ""
      this.ruleForm.destination = ""
      this.ruleForm.systemNumber = ""
      this.ruleForm.logisticsNumber = ""
      this.ruleForm.goodsCode = ""
      this.ruleForm.goodsName = ""
      this.ruleForm.waybillNo = ""
      this.ruleForm.sender = ""
      this.ruleForm.phone = ""
      this.ruleForm.serverName = ""
      this.ruleForm.returnGoodsInfo = [
          {
            goodsBarCode	: "",
            goodsName: "",
            quantity: 1,
            badQuantity: 0,
            validDate: "",
            allHislistShow: false,     // 效期历史记录数据默认隐藏
          },
        ]
    },
    toUrl(v) {
      if (v === "收费表单") {
        this.$router.push({
          path: "/service/charge-index/charge-record",
        });
      } else {
        this.$router.push({
          path: "/service/charge-index/charge-register",
        });
      }
    },
    addGoodsInfo() {
      let obj = {
        goodsBarCode	: "",
        goodsName: "",
        quantity: 1,
        badQuantity: 0,
        validDate: "",
        allHislistShow: ''
      };
      this.hislist = this.allHislist
      this.ruleForm.returnGoodsInfo.push(obj);
    },
    removeGoodsInfo(i) {
      this.ruleForm.returnGoodsInfo.splice(i, 1);
    },
    changeGoodsCode(val) {
      this.getGoodsName(val)
    },
    selectBlur(e){
      this.ruleForm.goodsName = e.target.value
    },
    childrenSelectBlur(e){
      let str = e.target.value
      if (str) {
        setTimeout(() => {
          this.ruleForm.returnGoodsInfo[this.goodsNameIndex].goodsName = str
        },200)
      }
    },
    visibleChangeSelect(e,i) {
      if (!e) {
        this.goodsNameIndex = i
      }
    },
    changeGoodsBarCode(val, index) {
      this.getGoodsName(val, index)
    },
    getGoodsName(code, index) {
      let customerId = this.ruleForm.userName
      ChargeRegister.getGoodsName(code, customerId).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.name = i
            arr.push(obj)
          })
          this.goodsNameList = arr
          if (this.ruleForm.serviceContent === this.SERVICE_CONTENT['退货服务']) {
            this.ruleForm.returnGoodsInfo[index].goodsName = this.goodsNameList[0].name
          } else {
            this.ruleForm.goodsName = this.goodsNameList[0].name
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    focusValidDate(row) {
      this.hislist = this.allHislist
      row.allHislistShow = true
    },
    blurValidDate(row) {
      setTimeout(() => {
        row.allHislistShow = false
      },300)
    },
    // 查询效期历史记录
    inputValidDate(val) {
     //toLowerCase():用于把字符串转为小写，让模糊查询更加清晰
      let _search = val.toLowerCase();
      let newListData = []; // 用于存放搜索出来数据的新数组
      if (_search) {
        this.allHislist.filter(item => {
          if (item.toLowerCase().indexOf(_search) !== -1) {
            newListData.push(item);
          }
        });
        this.hislist = newListData
      } else {
        this.hislist = this.allHislist
      }
    },
    // 保存效期历史记录
    changeValidDate(val) {
      if (val) {
        //判断是否有重复
        let index = this.allHislist.findIndex((ele) => {
          return ele == val;
        });
        //如果有的话就删除重复
        if (index != -1) {
          this.allHislist.splice(index, 1);
        }
        //向数组第一位添加
        this.allHislist.unshift(val);
        // 本地存储历史记录数组
        saveValidDateHislist(this.allHislist)
      }
    },
    selectValidDateHislist(row, v) {
      row.validDate = v
    }
  },
};
</script>
<style lang="scss" scoped>
.charge-register {
  flex: 1;
  display: flex;
  .charge-register-container {
    border-radius: 4px;
    .head {
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: 400;
      background: #f2f4f8;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .content {
      display: flex;
      justify-content: flex-start;
      .btn-blue {
        margin-top: 16px;
      }
      .top {
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        padding: 32px 37px 25px 37px;
        background: #fff;
        margin-bottom: 20px;
        border-radius: 8px;
        .serviceContent {
          width: 100%;
          border-bottom: 1px solid #eee;
          padding-bottom: 24px;
          .active {
            border-radius: 4px;
            background: #2e68ea;
            color: #fff;
          }
        }
        .orther-search {
          display: flex;
          justify-content: flex-start;
          .orther-search-title {
            font-size: 14px;
            line-height: 32px;
            text-align: left;
          }
          .orther-search-main {
            flex: 1;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
          }
        }
      }
      .main {
        background: #fff;
        padding: 37px;
        .main-title {
          display: flex;
          justify-content: space-between;
          height: 14px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          border-left: 3px solid #2e68ea;
          padding-left: 5px;
          margin-bottom: 10px;
          .add-goodsInfo {
            color: #2e68ea;
            cursor: pointer;
          }
        }
        .remarks {
          border-bottom: 1px solid #eee;
          padding-bottom: 10px;
          margin-bottom: 10px;
        }
      }
    }
    .return-goods {
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 10px;
      .del-content {
        width: 16px;
        padding-top: 16px;
      }
      .el-icon-delete {
        color: #2e68ea;
      }
    }
    .w200 {
      width: 200px;
    }
    .w160 {
      width: 175px;
    }
    .w150 {
      width: 130px;
    }
  }
  .allHislist {
    position: absolute;
    width: 100%;
    min-height: 32px;
    max-height: 200px;
    background: #fff;
    z-index: 1001;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba($color: #000000, $alpha: 0.1);
    box-sizing: border-box;
    margin: 5px 0;
    overflow-y: auto;
    .hislist {
      display: block;
      font-size: 14px;
      padding: 0 20px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #606266;
      height: 32px;
      line-height: 32px;
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        background-color: #F5F7FA;
      }
    }
  }
  .allHislist::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .allHislist::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }
  .allHislist::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }
}
</style>
<style lang="scss">
.charge-register {
  .top {
    .serviceContent {
      .el-form-item__label {
        text-align: left;
      }
      .el-form-item__content {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 30px !important;
        div {
          padding: 0px 8px;
          margin-right: 30px;
          cursor: pointer;
        }
      }
    }
    .warehouse-name {
      .el-form-item__label {
        width: 80px !important;
      }
      .el-form-item__content {
        margin-left: 80px !important;
      }
    }
    .project-name {
      .el-form-item__label {
        width: 80px !important;
      }
      .el-form-item__content {
        margin-left: 80px !important;
      }
    }
  }
  .main {
    .el-form-item {
      display: flex;
      flex-direction: column;
      .el-form-item__label {
        width: 120px !important;
        text-align: left;
      }
      .el-form-item__content {
        margin-left: 0px !important;
      }
    }
    .main-price {
      display: flex;
      .el-form-item {
        width: 20%;
        margin-right: 40px;
      }
    }
    .remarks {
      .el-form-item {
        width: 20%;
      }
    }
    .el-select {
      width: 100%;
    }
    .foot {
      align-items: center;
    }
  }
  .amount {
    .el-input.white .el-input__suffix {
      height: 32px;
      top: 0px;
      right: 14px;
    }
  }
}
</style>